import React, { useEffect, ReactNode } from "react";
import { RowContainer, ElementContainer } from "../containers/styledComponents";
import { CompassParagraph } from "./styledComponents";
import { greyText, darkGreen } from "../../styles";
import { Icon, IconContainer } from "../visuals/styledComponents";
// import bellIcon from "../../assets/svg/bell_icon.svg";
import logoutArrow from "../../assets/svg/logout_arrow.svg";
import { Avatar } from "../visuals/Avatar";
import { useUser } from "../../store/UserProvider";
import { MESSAGES } from "../../messages";
import { CompassDropdown } from "../visuals/CompassDropdown";
import { useLogin } from "../../hooks/useLogin";
import { GlobalSearchTrigger } from "./GlobalSearchTrigger";
import { JobsIndicator } from "../visuals/JobsIndicator";
import {
  UserRole,
  CognitoClaim,
  ManagerProfile,
} from "../../models/userModels";
import { usePost } from "../../hooks/usePost";

export const NavBar = ({ address }: NavBarProps): JSX.Element => {
  const { user, setUser } = useUser();
  const userRole = user?.[CognitoClaim.ROLE];
  const isUploadManager = userRole === UserRole.MANAGER_UPLOAD;

  const username = user?.[CognitoClaim.USERNAME] || MESSAGES.NOT_AVAILABLE;
  const userEmail = user?.email || "";
  const managerProfile = user?.managerProfile;

  const { sendData } = usePost<ManagerProfile, Record<string, never>>();

  useEffect(() => {
    const fetchManagerProfile = async (): Promise<void> => {
      if (isUploadManager && !managerProfile) {
        const profile = await sendData("GET_MANAGER_PROFILE", {});
        if (profile) {
          setUser((prev) =>
            prev ? { ...prev, managerProfile: profile } : prev,
          );
        }
      }
    };
    fetchManagerProfile();
  }, [isUploadManager, managerProfile, sendData, setUser]);

  // For upload managers: use email from Cognito token, fallback to username
  // For regular users: use username
  const displayName = isUploadManager ? userEmail || username : username;

  // Only show manager image if profile exists and has an image
  const managerImage =
    isUploadManager && managerProfile?.image ? managerProfile.image : undefined;

  const { handleLogout } = useLogin();
  return (
    <RowContainer jc="space-between" ai="center" mb={1} mt={1}>
      <ElementContainer>
        <CompassParagraph ml={12} mr={2} color={greyText}>
          Home /
        </CompassParagraph>
        <CompassParagraph ml={2} color={darkGreen}>
          {address}
        </CompassParagraph>
      </ElementContainer>
      <ElementContainer ai="center">
        <JobsIndicator />
        {!isUploadManager && <GlobalSearchTrigger />}
        {/* <IconContainer size={35} br={1} p={3} m={1}>
          <Icon src={bellIcon} />
        </IconContainer> */}
        <CompassDropdown
          title=""
          customDisplayComponent={
            <IconContainer size={60} br={50} p={1} m={1}>
              <Avatar username={displayName} image={managerImage} />
            </IconContainer>
          }
        >
          <ElementContainer
            ai="center"
            flexDirection="row"
            cursor="pointer"
            onClick={handleLogout}
          >
            <CompassParagraph
              color={greyText}
              mr={5}
              cursor="pointer"
              hoverUnderline={true}
            >
              Logout
            </CompassParagraph>
            <IconContainer size={15} p={1} m={1}>
              <Icon src={logoutArrow} />
            </IconContainer>
          </ElementContainer>
        </CompassDropdown>
        <CompassParagraph color={greyText} ml={-20}>
          {displayName}
        </CompassParagraph>
      </ElementContainer>
    </RowContainer>
  );
};

type NavBarProps = {
  address: ReactNode;
};
